import React from "react";

export default function HireButtons({ showOn = "both" }) {
  return (
    <div className={`hire-buttons ${showOn}`} style={{ display: "flex", gap: "14px" }}>
      {/* CONTRA */}
      <a
        href="https://contra.com/anastus_john_btejaygv"
        target="_blank"
        rel="noopener noreferrer"
        className="hire-btn contra"
      >
        Hire on Contra
      </a>

      {/* FIVERR */}
      <a
        href="https://www.fiverr.com/anastusjohn"
        target="_blank"
        rel="noopener noreferrer"
        className="hire-btn fiverr"
      >
        Hire on Fiverr
      </a>
      {/* FREELANCER */}
      <a
  href="https://www.freelancer.in/u/Anastus"
  target="_blank"
  rel="noopener noreferrer"
  className="hire-btn freelancer"
>
  Hire on Freelancer
</a>
    </div>
  );
}